import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { EllipsisModule } from 'ngx-ellipsis';
import { AssetsLibraryModule } from '../assets-library/assets-library.module';

import { FlowComponent } from './flow.component';
import { CopyFlowComponent } from './components/copy-flow/copy-flow.component';
import { DeleteFlowComponent } from './components/delete-flow/delete-flow.component';
import { MoveFlowComponent } from './components/move-flow/move-flow.component';
import { RenameFlowComponent } from './components/rename-flow/rename-flow.component';
import { PreviewComponent } from './components/preview/preview.component';
import { ChatBubbleComponent } from './components/preview/chat-bubble/chat-bubble.component';
import {
  ButtonsChatBubbleComponent,
} from './components/preview/chat-bubble/buttons-chat-bubble/buttons-chat-bubble.component';
import {
  ActionUrlChatBubbleComponent
} from './components/preview/chat-bubble/action-url-chat-bubble/action-url-chat-bubble.component';
import { FileComponent } from './components/preview/chat-bubble/file-chat-bubble/file-chat-bubble.component';
import { ImageComponent } from './components/preview/chat-bubble/image-chat-bubble/image-chat-bubble.component';
import {
  InteractiveMessageChatBubbleComponent,
} from './components/preview/chat-bubble/interactive-message-chat-bubble/interactive-message-chat-bubble.component';
import {
  LocationComponent,
} from './components/preview/chat-bubble/location-chat-bubble/location-chat-bubble.component';
import {
  OptionsChatBubbleComponent,
} from './components/preview/chat-bubble/options-chat-bubble/options-chat-bubble.component';
import { VideoComponent } from './components/preview/chat-bubble/video-chat-bubble/video-chat-bubble.component';
import { VoiceNoteComponent } from './components/preview/chat-bubble/voice-note/voice-note.component';
import { JsonToFromComponent } from './components/json-to-from/json-to-from.component';
import {
  FlowDeletionSuccessComponent,
} from './components/delete-flow/flow-deletion-success/flow-deletion-success.component';
import { FlowIssuesTableComponent } from './components/delete-flow/flow-issues-table/flow-issues-table.component';
import { ShowLocationComponent } from './components/preview/show-location/show-location.component';
import { ActionTypeComponent } from './components/json-to-from/action-type/action-type.component';
import { NextSelectorComponent } from './components/json-to-from/next-selector/next-selector.component';
import { EditNodeComponent } from './components/edit-node/edit-node.component';
import { RightSidebarComponent } from './components/right-sidebar/right-sidebar.component';
import { FlowNodeComponent } from './components/flow-node/flow-node.component';
import { NewNodeComponent } from './components/new-node/new-node.component';
import { VariableComponent } from './components/variable/variable.component';
import { RecycleBinComponent } from './components/recycle-bin/recycle-bin.component';
import { FlowStepSelectionComponent } from './components/flow-step-selection/flow-step-selection.component';
import { FlowDrawerComponent } from './components/flow-drawer/flow-drawer.component';
import { SelectMediaComponent } from './components/select-media/select-media.component';
import { NodeTypesComponent } from './components/node-types/node-types.component';

import {
  LeftSearchBarComponent,
  nodeIconPipe,
  nodeTypePipe,
  resultCountPipe,
  settingsDisplayPipe,
  stepNumberPipe,
  wordEclipsePipe,
} from './components/left-search-bar/left-search-bar.component';

// Pipes
import { RemoveWhiteSpacePipe } from '../../shared/utils/pipes/removeWhiteSpacePipe';
import { LowerCaseFirstLetterPipe } from '../../shared/utils/pipes/lowerCaseFirstLetterPipe';
import { UpperCaseFirstLetterPipe } from '../../shared/utils/pipes/upperCaseFirstLetterPipe';
import { NodeNamePipe } from '../../shared/utils/pipes/node-name.pipe';

import { FlowManagerService } from './services/flow-manager.service';
import { BotService } from './services/bot.service';
import { ZoomService } from './services/flowBuilder/zoom.service';
import { KeyEventsService } from './services/flowBuilder/key-events.service';
import { ReadReceiptComponent } from './components/preview/chat-bubble/read-receipt/read-receipt.component';
import { LogsComponent } from './components/logs/logs.component';
import { NodeDelegatorComponent } from './components/node-delegator/node-delegator.component';
import {
  MultipleChoiceComponent,
} from './components/node-delegator/nodes/menu/multiple-choice/multiple-choice.component';
import { VariableNodeComponent } from './components/node-delegator/nodes/actions/variable/variable-node.component';
import {
  DisplayTypeDialogComponent,
  SetDisplayTypeDisplayName,
  UpperCaseChannelName,
  CustomOptions
} from './components/node-delegator/nodes/templates/display-type-dialog/display-type-dialog.component';
import { DisplayTypeService } from './services/display-type.service';
import { DeleteGroupModalComponent } from './components/delete-group-modal/delete-group-modal.component';
import { ChatHubComponent } from './components/node-delegator/nodes/actions/chat-hub/chat-hub.component';
import { ValidatorsComponent } from './components/node-delegator/nodes/templates/validators/validators.component';
import { SwitchCaseComponent } from './components/node-delegator/nodes/actions/switch-case/switch-case.component';

import { BotTagsComponent } from './components/bots/bot-modal/bot-tags/bot-tags.component';
import { RenameTemplateComponent } from './components/bots/rename-template/rename-template.component';
import { ManagePlaceholderComponent } from './components/bots/manage-placeholder/manage-placeholder.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MenuFormComponent } from './components/node-delegator/nodes/menu/menu-form/menu-form.component';
import {
  SelectionPageComponent,
} from './components/node-delegator/nodes/menu/menu-form/pages/selection-page/selection-page.component';
import {
  PickerPageComponent,
} from './components/node-delegator/nodes/menu/menu-form/pages/picker-page/picker-page.component';
import {
  DatepickerPageComponent,
} from './components/node-delegator/nodes/menu/menu-form/pages/datepicker-page/datepicker-page.component';
import {
  InputPageComponent,
} from './components/node-delegator/nodes/menu/menu-form/pages/input-page/input-page.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import {
  InputValidatorsComponent,
} from './components/node-delegator/nodes/templates/input-validators/input-validators.component';
import { BotModalComponent } from './components/bots/bot-modal/bot-modal.component';
import {
  SaveToExistingBotModalComponent,
} from './components/bots/save-to-existing-bot-modal/save-to-existing-bot-modal.component';
import { DeleteBotModalComponent } from './components/bots/delete-bot-modal/delete-bot-modal.component';
import { DynamicListComponent } from './components/node-delegator/nodes/menu/dynamic-list/dynamic-list.component';
import {
  WaitForCallbackComponent,
} from './components/node-delegator/nodes/actions/wait-for-callback/wait-for-callback.component';
import { MultiProductComponent } from './components/node-delegator/nodes/menu/multi-product/multi-product.component';
import { FlowNodeDirective } from './components/flow-node/flow-node.directive';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import {
  CollectionsTableComponent,
} from '../analytics-settings/components/collections-table/collections-table.component';
import {
  AnalyticsSettingsComponent,
} from './components/node-delegator/nodes/templates/analytics-settings/analytics-settings.component';
import {
  RemoveCollectionComponent,
} from './components/analytics-setting/remove-collection/remove-collection.component';
import {
  ContactRecievingComponent,
} from './components/node-delegator/nodes/menu/contact-recieving/contact-recieving.component';
import {
  ContactSendingComponent,
} from './components/node-delegator/nodes/menu/contact-sending/contact-sending.component';
import { ReceiveContactComponent } from './components/preview/chat-bubble/receive-contact/receive-contact.component';
import { RequestLocationComponent } from './components/preview/chat-bubble/request-location/request-location.component';
import { Chat2payComponent } from './components/node-delegator/nodes/menu/chat2pay/chat2pay.component';
import { MatButtonModule } from '@angular/material/button';
import {
  CountrySelectComponent,
} from './components/node-delegator/nodes/templates/country-select/country-select.component';
import {
  SendContactCardComponent,
} from './components/preview/chat-bubble/send-contact-card/send-contact-card.component';
import { ContactDropdownButtonComponent } from './template/contact-dropdown-button/contact-dropdown-button.component';
import { ContactsTemplateComponent } from './template/contacts-template/contacts-template.component';
import {
  DecimalFormatComponent,
} from './components/node-delegator/nodes/actions/decimal-format/decimal-format.component';
import { WaTemplatePreviewComponent } from './template/wa-template-preview/wa-template-preview.component';
import { SendTemplateComponent } from './components/node-delegator/nodes/actions/send-template/send-template.component';
import { GetObjectKeysPipe } from '../../core/services/roles/get-object-keys.pipe';
import { EndFlowComponent } from './components/node-delegator/nodes/integrations/end-flow/end-flow.component';
import { AsyncApiComponent } from './components/node-delegator/nodes/integrations/async-api/async-api.component';
import { LocationNodeComponent } from './components/node-delegator/nodes/menu/location/location-node.component';
import { SelectMediaToggleComponent } from './components/select-media-toggle/select-media-toggle.component';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';
import { HttpCallComponent } from './components/node-delegator/nodes/actions/http-call/http-call.component';
import { IsEmptyComponent } from './components/node-delegator/nodes/actions/is-empty/is-empty.component';
import { IsNullComponent } from './components/node-delegator/nodes/actions/is-null/is-null.component';
import { AskInputComponent } from './components/node-delegator/nodes/menu/ask-input/ask-input.component';
import {
  RegularExpressionComponent,
} from './components/node-delegator/nodes/actions/regular-expression/regular-expression.component';
import { EncryptComponent } from './components/node-delegator/nodes/actions/encrypt/encrypt.component';
import { UrlPreviewComponent } from './components/preview/url-preview/url-preview.component';
import { MathComponent } from './components/node-delegator/nodes/actions/math/math.component';
import { OtpComponent } from './components/node-delegator/nodes/menu/otp/otp.component';
import { CustomTransformComponent } from './components/node-delegator/nodes/actions/custom-transform/custom-transform.component';
import { MediaComponent } from './components/node-delegator/nodes/menu/media/media.component';
import { DateFormatComponent } from './components/node-delegator/nodes/actions/date-format/date-format.component';
import { ChatdeskComponent } from './components/node-delegator/nodes/menu/chatdesk/chatdesk.component';
import { IsUserMessagePipe } from './components/preview/pipes/is-user-message.pipe';
import { GetListContentPipe } from './components/preview/pipes/get-list-content.pipe';
import { CoreModule } from '../../core/core.module';
import { RemapComponent } from './components/node-delegator/nodes/actions/remap/remap.component';
import { DisplayListComponent } from './components/node-delegator/nodes/actions/display-list/display-list.component';
import { MenuOptionComponent } from './components/node-delegator/nodes/menu/menu-option/menu-option.component';
import { OrcaPaymentComponent } from './components/node-delegator/nodes/menu/orca-payment/orca-payment.component';
import { AuthenticateComponent } from './components/node-delegator/nodes/menu/authenticate/authenticate.component';
import {
  FundingSourceReserveComponent,
} from './components/node-delegator/nodes/integrations/funding-source-reserve/funding-source-reserve.component';
import {
  FundingSourceConfirmComponent,
} from './components/node-delegator/nodes/integrations/funding-source-confirm/funding-source-confirm.component';
import { VendorVendComponent } from './components/node-delegator/nodes/integrations/vendor-vend/vendor-vend.component';
import { AiAssistantComponent } from './components/node-delegator/nodes/menu/ai-assistant/ai-assistant.component';
import { RedisComponent } from './components/node-delegator/nodes/actions/redis/redis.component';
import { DisplayMenuComponent } from './components/node-delegator/nodes/menu/display-menu/display-menu.component';
import { ImessageComponent } from './components/node-delegator/nodes/menu/imessage/imessage.component';
import { OptOutComponent } from './components/node-delegator/nodes/actions/opt-out/opt-out.component';
import { DeleteOptOutComponent } from './components/node-delegator/nodes/actions/delete-opt-out/delete-opt-out.component';
import { VerifyOptOutComponent } from './components/node-delegator/nodes/actions/verify-opt-out/verify-opt-out.component';
import {
  NestedEndNodeComponent
} from './components/node-delegator/nodes/integrations/nested-end-node/nested-end-node.component';
import { NestedNodeComponent } from './components/node-delegator/nodes/integrations/nested-node/nested-node.component';
import {
  ApiEndNodeComponent
} from './components/node-delegator/nodes/integrations/api-end-node/api-end-node.component';
import { ExternalLinkComponent } from './components/node-delegator/nodes/menu/external-link/external-link.component';
import {
  WhatsAppSettingsComponent
} from './components/node-delegator/nodes/templates/whats-app-settings/whats-app-settings.component';
import { RichLinkComponent } from './components/node-delegator/nodes/menu/rich-link/rich-link.component';

export const OtherOptions: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchGestures: 'auto',
  position: 'before',
  touchendHideDelay: 0,
  disableTooltipInteractivity: true,
};

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    EllipsisModule,
    AssetsLibraryModule,
    ClipboardModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxDaterangepickerMd.forRoot(),
    CoreModule,
  ],
  declarations: [
    FlowComponent,
    CopyFlowComponent,
    DeleteFlowComponent,
    MoveFlowComponent,
    RenameFlowComponent,
    PreviewComponent,
    UrlPreviewComponent,
    ChatBubbleComponent,
    ButtonsChatBubbleComponent,
    ActionUrlChatBubbleComponent,
    FileComponent,
    ImageComponent,
    InteractiveMessageChatBubbleComponent,
    LocationComponent,
    OptionsChatBubbleComponent,
    VideoComponent,
    VoiceNoteComponent,
    JsonToFromComponent,
    FlowDeletionSuccessComponent,
    FlowIssuesTableComponent,
    ShowLocationComponent,
    ActionTypeComponent,
    NextSelectorComponent,
    EditNodeComponent,
    RightSidebarComponent,
    FlowNodeComponent,
    NewNodeComponent,
    VariableComponent,
    RecycleBinComponent,
    FlowStepSelectionComponent,
    FlowDrawerComponent,
    SelectMediaComponent,
    NodeTypesComponent,
    RemoveWhiteSpacePipe,
    LowerCaseFirstLetterPipe,
    UpperCaseFirstLetterPipe,
    NodeNamePipe,
    ReadReceiptComponent,
    LogsComponent,
    NodeDelegatorComponent,
    MultipleChoiceComponent,
    VariableNodeComponent,
    DisplayTypeDialogComponent,
    SetDisplayTypeDisplayName,
    UpperCaseChannelName,
    CustomOptions,
    DeleteGroupModalComponent,
    ChatHubComponent,
    ValidatorsComponent,
    MenuFormComponent,
    SelectionPageComponent,
    PickerPageComponent,
    DatepickerPageComponent,
    InputPageComponent,
    FlowNodeDirective,
    InputValidatorsComponent,
    DeleteGroupModalComponent,
    BotModalComponent,
    BotTagsComponent,
    SaveToExistingBotModalComponent,
    RenameTemplateComponent,
    ManagePlaceholderComponent,
    SaveToExistingBotModalComponent,
    DeleteBotModalComponent,
    DynamicListComponent,
    ImessageComponent,
    WaitForCallbackComponent,
    MultiProductComponent,
    SwitchCaseComponent,
    CollectionsTableComponent,
    AnalyticsSettingsComponent,
    RemoveCollectionComponent,
    RequestLocationComponent,
    Chat2payComponent,
    ContactRecievingComponent,
    ContactSendingComponent,
    DisplayMenuComponent,
    ReceiveContactComponent,
    CountrySelectComponent,
    SendContactCardComponent,
    ContactDropdownButtonComponent,
    ContactsTemplateComponent,
    DecimalFormatComponent,
    ContactsTemplateComponent,
    WaTemplatePreviewComponent,
    SendTemplateComponent,
    GetObjectKeysPipe,
    EndFlowComponent,
    AsyncApiComponent,
    LocationNodeComponent,
    SelectMediaToggleComponent,
    HttpCallComponent,
    SelectMediaToggleComponent,
    IsEmptyComponent,
    IsNullComponent,
    AskInputComponent,
    RegularExpressionComponent,
    EncryptComponent,
    MathComponent,
    RedisComponent,
    OtpComponent,
    DateFormatComponent,
    ChatdeskComponent,
    OtpComponent,
    IsUserMessagePipe,
    GetListContentPipe,
    MediaComponent,
    OtpComponent,
    LeftSearchBarComponent,
    resultCountPipe,
    settingsDisplayPipe,
    stepNumberPipe,
    nodeTypePipe,
    nodeIconPipe,
    wordEclipsePipe,
    MediaComponent,
    OtpComponent,
    RemapComponent,
    DisplayListComponent,
    MenuOptionComponent,
    OrcaPaymentComponent,
    AuthenticateComponent,
    FundingSourceReserveComponent,
    FundingSourceConfirmComponent,
    VendorVendComponent,
    AiAssistantComponent,
    ExternalLinkComponent,
    wordEclipsePipe,
    NestedEndNodeComponent,
    NestedNodeComponent,
    ApiEndNodeComponent,
    CustomTransformComponent,
    RedisComponent,
    OptOutComponent,
    DeleteOptOutComponent,
    VerifyOptOutComponent,
    WhatsAppSettingsComponent,
    VerifyOptOutComponent,
    RichLinkComponent,
  ],
  exports: [
    FlowComponent,
    CopyFlowComponent,
    DeleteFlowComponent,
    MoveFlowComponent,
    RenameFlowComponent,
    PreviewComponent,
    ButtonsChatBubbleComponent,
    ActionUrlChatBubbleComponent,
    FileComponent,
    ImageComponent,
    InteractiveMessageChatBubbleComponent,
    LocationComponent,
    OptionsChatBubbleComponent,
    VideoComponent,
    VoiceNoteComponent,
    JsonToFromComponent,
    FlowDeletionSuccessComponent,
    FlowIssuesTableComponent,
    ShowLocationComponent,
    ActionTypeComponent,
    NextSelectorComponent,
    EditNodeComponent,
    RightSidebarComponent,
    FlowNodeComponent,
    NewNodeComponent,
    VariableComponent,
    RecycleBinComponent,
    FlowStepSelectionComponent,
    FlowDrawerComponent,
    SelectMediaComponent,
    NodeTypesComponent,
    LogsComponent,
    NodeDelegatorComponent,
    ClipboardModule,
    FlowNodeDirective,
    CollectionsTableComponent,
    LeftSearchBarComponent,
    resultCountPipe,
    settingsDisplayPipe,
    stepNumberPipe,
    nodeTypePipe,
    nodeIconPipe,
    wordEclipsePipe,
  ],
  entryComponents: [
    CopyFlowComponent,
    DeleteFlowComponent,
    MoveFlowComponent,
    RenameFlowComponent,
  ],
  providers: [
    FlowManagerService,
    BotService,
    ZoomService,
    KeyEventsService,
    DisplayTypeService,
    { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: OtherOptions },
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})
export class FlowModule {
}
